import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation } from 'react-query'
import useEventLogger from '../hooks/useEventLogger'

type UnimportActivityVariables = {
    activityId: string
    roadmapId: string
    activityData?: unknown
}

export const useUnimportActivityMutation = () => {
    const { logEvent, ACTIONS } = useEventLogger()
    const { getTokenSilently } = useAuth0()

    const unimportActivity = async ({ activityId, roadmapId, activityData }: UnimportActivityVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { method } = endpoints.unimportActivity
        const url = `${endpoints.unimportActivity.url}${activityId}/roadmap/${roadmapId}/unimport`

        const response = await callAPI(url, method, token)

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to remove activity from roadmap')
        }

        logEvent(ACTIONS.UNIMPORT, { type: 'Activity', data: activityData })
    }

    return useMutation(unimportActivity)
}
